export default __webpack_public_path__ + "static/logo-payperks-1d70db50175efca5207e315c8683aed3.svg";